var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutopilotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00004 0.333496C6.71682 0.333496 6.48945 0.563898 6.46618 0.846163C6.21966 3.83597 3.83641 6.21977 0.846042 6.4663C0.563777 6.48957 0.333374 6.71694 0.333374 7.00016C0.333374 7.28339 0.563776 7.51076 0.846042 7.53403C3.83641 7.78055 6.21966 10.1644 6.46618 13.1542C6.48945 13.4364 6.71682 13.6668 7.00004 13.6668C7.28326 13.6668 7.51063 13.4364 7.53391 13.1542C7.78042 10.1644 10.1637 7.78055 13.154 7.53403C13.4363 7.51076 13.6667 7.28339 13.6667 7.00016C13.6667 6.71694 13.4363 6.48957 13.154 6.4663C10.1637 6.21977 7.78042 3.83597 7.53391 0.846163C7.51063 0.563898 7.28326 0.333496 7.00004 0.333496Z",
    fill: "#FA4616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutopilotIcon);
export default __webpack_public_path__ + "static/media/Autopilot-Icon.243cd2e3a85254efb3ebe7bd139969e6.svg";
export { ForwardRef as ReactComponent };